import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import NotificationBadge from 'components/ui/NotificationBadge';

const NavigationItem = ({
  label,
  path,
  iconName,
  badgeCount = 0,
  isCollapsed = false,
  onClick,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location?.pathname === path;

  const handleClick = () => {
    navigate(path);
    if (onClick) onClick();
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      role="menuitem"
      tabIndex={0}
      aria-current={isActive ? 'page' : undefined}
      aria-label={label}
      className={`nav-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <span className="nav-item-icon">
        <Icon
          name={iconName}
          size={18}
          color={isActive ? 'var(--color-primary-foreground)' : 'currentColor'}
          strokeWidth={isActive ? 2.5 : 2}
        />
      </span>

      <span className="nav-item-label">{label}</span>

      {badgeCount > 0 && (
        <NotificationBadge count={badgeCount} />
      )}

      {/* Tooltip shown only when sidebar is collapsed */}
      <span className="nav-tooltip" aria-hidden="true">
        {label}
        {badgeCount > 0 && ` (${badgeCount})`}
      </span>
    </div>
  );
};

export default NavigationItem;